import { render, staticRenderFns } from "./already-using.vue?vue&type=template&id=23588ad2&scoped=true"
var script = {}
import style0 from "./already-using.vue?vue&type=style&index=0&id=23588ad2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23588ad2",
  null
  
)

export default component.exports